export default __webpack_public_path__ + "static/media/5581f74ed305a6edfff64540b8a3d88a.svg";